<ul class="voter-badges" [attr.aria-label]="'Votos do comitê'">
  @for (voter of voters(); track $index) {
    <li
      class="voter-badge voter-badge--{{ tone(voter.vote) }}"
      [class.voter-badge--me]="voter.isMe"
      [pTooltip]="describe(voter)"
      tooltipPosition="right"
      [attr.aria-label]="describe(voter)">
      {{ initials(voter.name) }}
    </li>
  }
</ul>
